/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import styles from './HeroSplit.module.css';

import s2 from '../images/תמונות פתיחה שובל 2.webp';
import h1 from '../images/בית של טבע וחומר 3.webp';
import duskHome from '../images/בית חזית בין ערביים.webp';
import whiteVilla from '../images/בית של אור ועיצוב 1.webp';
import hero1Desk from '../images/image1_full_5x4.webp';
import hero1Mob from '../images/שובל מסך פתיחה נוספות 1.webp';
import logo from '../images/לוגו שובל רוימי 1.webp';

const SLIDES = [
  { src: hero1Desk, mobSrc: hero1Mob, mob: 'center 40%', desk: 'center 45%', alt: 'פרויקט אדריכלות בתכנון סטודיו SRA - שובל רוימי אביסרור' },
  { src: duskHome, mob: 'center 45%', desk: 'center 50%', alt: 'בית פרטי מודרני בשעת בין ערביים - חזית מוארת, בריכה וגינה בתכנון סטודיו SRA' },
  { src: whiteVilla, mob: 'center 40%', desk: 'center 48%', alt: 'וילה מודרנית לבנה עם בריכה וגינה - אדריכלות ועיצוב פנים בתכנון סטודיו SRA' },
  { src: s2, mob: 'center 40%', desk: 'center 30%', alt: 'חלל מגורים בעיצוב סטודיו SRA - מדרגות דאבל הייט עם נברשות וגווני קרם חמים' },
  { src: h1, mob: 'center 40%', desk: 'center 45%', alt: 'סלון בית פרטי עם תקרת עץ, אבן טבעית ונוף לבריכה - עיצוב סטודיו SRA' },
];

const WA_LINK = `https://wa.me/972504499737?text=${encodeURIComponent('היי שובל, אשמח לשמוע פרטים על תכנון אדריכלי.')}`;

function HeroSplit({ onOpenLead }) {
  const [slide, setSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 820 : false
  );

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 820);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    const id = setInterval(() => setSlide((s) => (s + 1) % SLIDES.length), 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <section className={`${styles.hero} ${loaded ? styles.loaded : ''}`}>
      {/* ——— Image layer ——— */}
      <div className={styles.imageLayer}>
        {SLIDES.map((s, i) => {
          /* Only the first slide is the LCP. The rest are deferred until
             after the initial paint to keep the hero fast, and marked
             lazy/low-priority so they never compete with the LCP image. */
          if (i !== 0 && !loaded) return null;
          return (
            <img
              key={i}
              src={isMobile && s.mobSrc ? s.mobSrc : s.src}
              alt={s.alt}
              className={`${styles.slideImg} ${i === slide ? styles.slideActive : ''}`}
              style={{ objectPosition: isMobile ? s.mob : s.desk }}
              loading={i === 0 ? 'eager' : 'lazy'}
              decoding="async"
              fetchPriority={i === 0 ? 'high' : 'low'}
            />
          );
        })}
        <div className={styles.imageOverlay} />
      </div>

      {/* ——— Content card ——— */}
      <div className={styles.card}>
        <div className={styles.cardInner}>
          {/* Logo */}
          <img src={logo} alt="לוגו סטודיו SRA - שובל רוימי אביסרור, אדריכלות ועיצוב פנים" className={styles.logo} loading="eager" decoding="async" />

          {/* Headline */}
          <h1 className={styles.headline}>
            <span className={styles.headlineLine}>אדריכלות ועיצוב פנים</span>
            <span className={`${styles.headlineLine} ${styles.headlineAccent}`}>מקצה לקצה.</span>
          </h1>

          {/* Subtext */}
          <p className={styles.subtext}>
            מהפגישה הראשונה, דרך ההיתר והפיקוח, ועד שהכוסות על השיש - סטודיו SRA
            מלווה משפחות שבונות בית פרטי בתהליך שקוף, מדויק, ובלי חריגות.
          </p>

          {/* CTA */}
          <div className={styles.ctaRow}>
            <button type="button" onClick={onOpenLead} className={styles.ctaPrimary}>
              <span>לשיחת ייעוץ ללא עלות</span>
            </button>
            <button className={styles.ctaGhost} onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}>
              <span>הפרויקטים שלנו</span>
              <span className={styles.ctaArrow}>&larr;</span>
            </button>
          </div>

          {/* Scroll hint */}
          <button
            type="button"
            className={styles.scrollHint}
            onClick={() => document.getElementById('pitch')?.scrollIntoView({ behavior: 'smooth' })}
            aria-label="גללו למטה"
          >
            <span className={styles.scrollHintText}>גללו למטה</span>
            <span className={styles.scrollHintLine}>
              <span className={styles.scrollHintDot} />
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default HeroSplit;
